export default __webpack_public_path__ + "static/media/no-active-devices.49c47eb0.svg";